export default {
  common: {
    login: 'Login',
    logout: 'Logout',
    support: 'Support',
    privacy: 'Privacy policy',
    terms: 'Terms of service',
    and: 'and',
    guest: 'Guest',
    loading: 'Loading',
    play: 'Play',
    install: 'Install',
  },
  auth: {
    loading: '@:(common.loading)...',
  },
  support: {
    title: 'Need support?',
    description: `If you are a user of this game and you have any difficulties,
      we will be happy to help you and answer all questions`,
    button: '@:common.support',
  },
  homescapes: {
    title: 'Homescapes',
    caption: `Help Austin the butler bring warmth and comfort back to his wonderful family's mansion.`,
    description: `Help Austin the butler bring warmth and comfort back
      to his wonderful family's mansion. Come on in — adventures
      await you from the moment you walk in the door!`,
  },
  cookie: {
    message: 'This website uses cookies to ensure you get the best experience on our website',
    link: 'More info',
    button: 'Accept',
  },
  install: {
    title: '@:common.install',
    text: `Homescapes on your desktop!
    Install the web version of the game and visit Austin in just a couple of clicks!`,
    button: '@:common.install',
  },
  copy: {
    xsolla: 'Xsolla is an authorized global distributor of Homescapes',
  },
  game: {
    notSupported: `Mobile devices are not supported.
      Log in from your computer to play.`,
  },
};
